import { useAppStore } from '@/store/store';
import { Tooltip } from '@/components/shared/Tooltip';
import { ScrubInput } from 'calc-controls';

export function DimDivisorInput() {
  const dimDivisor = useAppStore((s) => s.dimDivisor);
  const divisorOverridden = useAppStore((s) => s.divisorOverridden);
  const setDimDivisor = useAppStore((s) => s.setDimDivisor);
  const resetDivisor = useAppStore((s) => s.resetDivisor);

  const unitLabel = dimDivisor >= 1000 ? 'cm³/kg' : 'in³/lb';

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)' }}>
      <Tooltip content="The divisor used to convert volume into dimensional weight. Lower divisor = higher DIM weight.">
        <label htmlFor="dim-divisor" style={{ fontSize: 'var(--font-size-sm)', fontWeight: 'var(--font-weight-medium)', cursor: 'help' }}>
          DIM Divisor
        </label>
      </Tooltip>
      <ScrubInput
        value={dimDivisor}
        onChange={setDimDivisor}
        unit={unitLabel}
        min={1}
        step={100}
        decimals={0}
        inline
      />
      {divisorOverridden && (
        <button
          className="btn btn-sm"
          onClick={resetDivisor}
          style={{ fontSize: 'var(--font-size-xs)' }}
        >
          Reset
        </button>
      )}
    </div>
  );
}
